export enum FileBlobResponseFields {
    File = 'file',
    FileName = 'fileName'
}

export interface FileBlobResponse {
    [FileBlobResponseFields.File]: any
    [FileBlobResponseFields.FileName]: string
}
